class LSystem {
    constructor() {
        this.string = 'S';
        // this.rules=[[/[S]/gm, ['FFRFB', 'RFB']], [/[B]/gm, ['BFS']], [/[R]/gm, ['/', '\\', '^', '&', '+', '-']]];
        // this.rules=[[/[S]/gm, ['RFBFBS', 'FBL']], [/[L]/gm, ['(/^FBFBS)', '(/&FBFBS)', '(\\^FBFBS)', '(\\&FBFBS)']], [/[R]/gm, ['/', '\\', '^', '&', '+', '-']]];
        // this.rules=[[/[S]/gm, ['RGGS']], [/[R]/gm, ['/', '\\']], [/[G]/gm, ['^FB^FB', '^FB^FB', '&FB&FB']]];
    }

    nextStep(amount) {
        for(let i=0; i < amount; i++) {
            this.rules.forEach(([rule, replacements]) => {
                // console.log(rule);
                this.string = this.string.replace(rule, replacements[Math.floor(Math.random() * replacements.length)]);
            });
        }
        // console.log(this.string);
    }
}

export default LSystem;